const hu = {
    common: {
        history: "történelmi változata"
    }
};
export default hu;



// WEBPACK FOOTER //
// ./src/i18n/langs/hu.js